module.exports = __webpack_public_path__ + "img/publication_1.4bc26e59.svg";